<template>
    <section class="content-blocks">
        <template v-for="(block, index) in contentBlocks">
            <component
                :is="map[block.__typename]"
                v-if="block.__typename"
                :key="index"
                :block="block"
                :index="index"
            />
        </template>
    </section>
</template>

<script>
import RichTextBlock from './blocks/rich-text.vue';
import TextColumnsBlock from './blocks/text-columns.vue';
import ImageBlock from './blocks/image.vue';
import VideoBlock from './blocks/video.vue';
import TextImageBlock from './blocks/text-image.vue';
import LeadTextBlock from './blocks/lead-text.vue';
import CallToActionBlock from './blocks/call-to-action.vue';
import EmployeesBlock from './blocks/employees.vue';
import AccordionBlock from './blocks/accordion.vue';
import QuoteBlock from './blocks/quote.vue';
import DownloadsBlock from './blocks/downloads.vue';
import SliderBlock from './blocks/slider.vue';
import FormBlock from '~/layers/craft/formie/components/ContentBlocksForm.vue';

const graphToComponentMapping = {
    'contentBlocks_textBlock_BlockType': RichTextBlock,
    'contentBlocks_textColumnsBlock_BlockType': TextColumnsBlock,
    'contentBlocks_imageBlock_BlockType': ImageBlock,
    'contentBlocks_videoBlock_BlockType': VideoBlock,
    'contentBlocks_textImageBlock_BlockType': TextImageBlock,
    'contentBlocks_leadTextBlock_BlockType': LeadTextBlock,
    'contentBlocks_callToActionBlock_BlockType': CallToActionBlock,
    'contentBlocks_employeesBlock_BlockType': EmployeesBlock,
    'contentBlocks_accordionBlock_BlockType': AccordionBlock,
    'contentBlocks_quoteBlock_BlockType': QuoteBlock,
    'contentBlocks_downloadsBlock_BlockType': DownloadsBlock,
    'contentBlocks_formie_BlockType': FormBlock,
    'contentBlocks_slider_BlockType': SliderBlock
};

export default {
    props: {
        contentBlocks: {
            type: Array,
            required: false,
            default: () => { return []; }
        }
    },
    computed: {
        map: () => graphToComponentMapping
    }
};
</script>

<style lang="less" src="./content-blocks.less"></style>
